// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
function CustomActionButton(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var customAction = Props.customAction;
  var renderDefault = Props.renderDefault;
  var onClick = Props.onClick;
  var html = Belt_Option.keep(Belt_Option.flatMap(customAction.renderFn, function (code) {
    return CustomScript$Showside.triggerCustomFunctionReturningString(code, product, variant, "Size guide custom action", undefined, undefined);
  }), function (html) {
    return html.trim() !== "";
  });
  if (html !== undefined) {
    return React.createElement("span", {
      onClick: onClick,
      dangerouslySetInnerHTML: {
        __html: html
      }
    });
  } else {
    return React.createElement("span", {
      onClick: onClick
    }, renderDefault);
  }
}
CustomActionButton.displayName = "CustomActionButton";
var make = CustomActionButton;
export { make };
/* react Not a pure module */